module.exports = __webpack_public_path__ + "static/img/17.ce0c61d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/temp/17.jpg
// module id = wmd+
// module chunks = 36